// extracted by mini-css-extract-plugin
export default {"whatsapp_button":"ShareButton_whatsapp_button__kdUDI","wikiloc_button":"ShareButton_wikiloc_button__mNap-","email_button":"ShareButton_email_button__-A3-v"};